import {ref, Ref} from "vue"

const isHaveDetailResponse: Ref<boolean> = ref(false)

export default isHaveDetailResponse